// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const useStyles = (theme: any) => ({
  popper: {
    zIndex: 1000,
    width: 350,
  },
  downloadPanelDialog: {
    '& .MuiDialog-paper': {
      minWidth: '42rem',
      maxWidth: '42rem',
      width: '100%',
    },
  },
  downloadPanel: {
    padding: theme.spacing(2),
  },
  downloadButtons: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gridRowGap: theme.spacing(0.5),
    gridColumnGap: theme.spacing(),
    alignItems: 'center',
    wordBreak: 'break-all',
  },
  downloadButton: {
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: theme.spacing(),
    paddingRight: theme.spacing(),
    minWidth: '7rem',
    textTransform: 'uppercase',
  },
  buttonProgress: {
    marginRight: theme.spacing(1),
  },
  snackBar: {
    top: '90px',
    bottom: '0px',
  },
  alert: {
    backgroundColor: 'white',
  },
  header: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '10px',
    padding: theme.spacing(2, 3),
  },
  title: {
    fontSize: '18px',
    textTransform: 'none',
    marginBottom: theme.spacing(1),
  },
  description: {
    paddingLeft: theme.spacing(3),
  },
  icon: {
    fontSize: theme.spacing(2),
    cursor: 'pointer',
  },
  link: {
    color: theme.palette.primary.main,
  },
  expressButtonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-8px',
    marginLeft: '-8px',
  },
  warningIcon: {
    color: theme.palette.primary.main,
    fontSize: '26px',
  },
  warningTitle: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    alignItems: 'center',
    padding: '16px 24px',
    gridColumnGap: theme.spacing(1),
  },
  dialog: {
    minWidth: '600px',
    margin: 'auto',
  },
  dialogContent: {
    padding: theme.spacing(2),
  },
  deliveryDate: {
    color: theme.palette.primary.main,
  },
  emptyLayers: {
    '& .MuiFormControlLabel-root': {
      marginLeft: '22px',
    },
    '& .MuiFormControlLabel-label': {
      fontSize: '14px',
    },
  },
  checkboxContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: theme.spacing(3),
    marginTop: theme.spacing(2),
  },
  smallCheckbox: {
    '& .MuiSvgIcon-root': {
      width: '18px',
    },
    padding: '2px 9px',
    '&.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '10px',
    padding: theme.spacing(2),
  },
  cancelButton: {
    color: '#021E40',
    opacity: '50%',
    fontSize: theme.spacing(2),
  },
  fileTitle: { fontWeight: 600 },
  fileContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 2),
  },
  fileContainerHover: {
    '&:hover': {
      borderRadius: '5px',
      backgroundColor: theme.palette.action.hover,
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    },
  },
  fileDisabled: {
    opacity: 0.5,
  },
  fileDownloadIconButton: {
    marginRight: theme.spacing(1),
  },
  fileDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  prepareDownloadInfo: {
    backgroundColor: '#FFF4E5',
    padding: theme.spacing(1, 2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(3),
  },
  infoIcon: {
    color: '#FAA738',
  },
  prepareDownloadInfoText: {
    fontFamily: 'Work Sans',
    fontSize: '14px',
    fontWeight: 400,
  },
});

export default useStyles;
